//need jquery to work
GLOBALVARS = {};

function testIEandChrome(ua, tem, M) {
	if (/trident/i.test(M[1])) {
		tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
		return 'IE ' + (tem[1] || '');
	}
	if (M[1] === 'Chrome') {
		tem = ua.match(/\bOPR\/(\d+)/);
		if (tem !== null) {
			return 'Opera ' + tem[1];
		}
	}
	return null;
}

function get_browser() {
	var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

	var res = testIEandChrome(ua, tem, M);
	if (res) {
		return res;
	}

	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) !== null) {
		M.splice(1, 1, tem[1]);
	}
	return M[0];
}

function get_browser_version() {
	var ua = navigator.userAgent, tem, M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];

	var res = testIEandChrome(ua, tem, M);
	if (res) {
		return res;
	}

	M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?'];
	if ((tem = ua.match(/version\/(\d+)/i)) != null) {
		M.splice(1, 1, tem[1]);
	}
	return M[1];
}

function getOs() {
	var appVersion = navigator.appVersion;
	var osDesc = 'os';
	if (appVersion.indexOf('Win') !== -1) {
		osDesc = 'windows';
	} else if (appVersion.indexOf('Mac') !== -1) {
		osDesc = 'macos';
	}
	return osDesc;
}

function getBrowserInfos() {
	var browserType;
	var tooOld = false;
	var browserDesc = 'browser';
	var agt = navigator.userAgent.toLowerCase();
	var ver = get_browser_version();

	if (agt.indexOf('firefox') !== -1) {
		browserDesc = 'firefox';
		if (ver < 3.6) {
			tooOld = true;
		}
	}

	if (agt.indexOf('chrome') !== -1) {
		browserDesc = 'chrome';
	} else if (agt.indexOf('safari') !== -1) {
		browserDesc = 'safari';
		var v = navigator.userAgent.match(/version\/([0-9]+[.]?)*/i);
		ver = v && v[0] ? v[0].match(/([0-9]+.?[0-9]*.?[0-9]*)/i)[0] : 0;
		if (ver < 5.1) {
			tooOld = true;
		}
	}

	browserType = browserDesc;

	if (navigator.appName === 'Microsoft Internet Explorer' || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
		browserType = 'ie';
		browserDesc = 'ie11';
		ver = '11.0';
	}

	if (/MSIE (\d+\.\d+);/.test(navigator.userAgent)) {
		browserType = 'ie';
		ver = 0;
		var re = new RegExp('MSIE ([0-9]{1,}[\.0-9]{0,})');
		if (re.exec(navigator.userAgent) !== null) {
			ver = parseFloat(RegExp.$1);
		}

		if (ver < 7.0) {
			browserDesc = 'ie6';
			tooOld = true;
		} else if (ver < 8.0) {
			browserDesc = 'ie7';
			tooOld = true;
		} else if (ver < 9.0) {
			tooOld = true;
			browserDesc = 'ie8';
		} else if (ver < 10.0) {
			browserDesc = 'ie9';
		} else if (ver < 11.0) {
			browserDesc = 'ie10';
		}
	}
	return {
		browserType: browserType,
		browserDesc: browserDesc,
		tooOld: tooOld
	};
}

function markConfigurationToBody() {
	var agt = navigator.userAgent.toLowerCase();

	//os
	//var browser = get_browser();
	var ver = get_browser_version();
	var osDesc = getOs();


	var infos = getBrowserInfos();
	var browserType = infos['browserType'];
	var browserDesc = infos['browserDesc'];
	var tooOld = infos['tooOld'];


	if (agt.indexOf('iphone') !== -1) {
		browserDesc = 'iphone';
		browserType = 'iphone';
	}
	if (agt.indexOf('android') !== -1) {
		browserDesc = 'android';
		browserType = 'android';
	}

	var mobile = false;
	if (agt.match(/(android|iphone|ipad|blackberry|symbian|symbianos|symbos|netfront|model-orange|javaplatform|iemobile|windows phone|samsung|htc|opera mobile|opera mobi|opera mini|presto|huawei|blazer|bolt|doris|fennec|gobrowser|iris|maemo browser|mib|cldc|minimo|semc-browser|skyfire|teashark|teleca|uzard|uzardweb|meego|nokia|bb10|playbook)/gi)) {
		mobile = true;
	}

	browserDescGlobal = browserDesc;

	GLOBALVARS['browser'] = {
		os: osDesc,
		version: ver,
		type: browserType,
		description: browserDesc,
		mobile: mobile
	};
	//marquage
	//browser
	document.getElementsByTagName('body')[0].className += ' ' + osDesc;
	document.getElementsByTagName('body')[0].className += ' ' + browserDesc;
	document.getElementsByTagName('body')[0].className += ' ' + browserType;
	if (tooOld) {
		document.getElementsByTagName('body')[0].className += ' old-browser';
	}
	//alert(document.getElementsByTagName('body')[0].className);
}
//window.onload = markConfigurationToBody;
markConfigurationToBody();

